import { Responsive } from '@cian/ui-kit/responsive';
import classNames from 'clsx';
import * as React from 'react';

import * as styles from './Card.css';
import { CardContainer } from './CardContainer';
import { LinkArea } from '../LinkArea';
import { stopPropagation } from '../../utils/event';

interface ICardProps {
  content: React.ReactNode;
  favorite: React.ReactNode;
  gallery: React.ReactNode;
  href: string;
  actionButtonPhone: React.ReactNode;
  labels: React.ReactNode | null;
  promoted: boolean;
  actionButtonDesktop: React.ReactNode;
  thumbnails: React.ReactNode;
  brandingBanner?: React.ReactNode | null;

  onClick?: VoidFunction;
}

// eslint-disable-next-line react/display-name
const CardComponent = React.forwardRef<HTMLDivElement, ICardProps>((props, ref) => {
  const {
    content,
    favorite,
    gallery,
    href,
    actionButtonPhone,
    labels,
    promoted,
    actionButtonDesktop,
    thumbnails,
    brandingBanner,
    onClick,
  } = props;

  return (
    <CardContainer>
      <div className={styles['card']} ref={ref}>
        <Responsive phone>{brandingBanner}</Responsive>
        <a className={styles['media']} href={href} target="_blank" rel="noreferrer" draggable={false} onClick={onClick}>
          <div className={styles['favorite-button']}>{favorite}</div>
          <div data-name="Gallery" className={classNames(styles['gallery'], promoted && styles['gallery_promoted'])}>
            {gallery}
          </div>
          {thumbnails}
        </a>
        <div className={styles['content']} data-name="CardContent">
          {labels}
          <LinkArea href={href} target="_blank" className={styles['content--link']} onClick={onClick}>
            {content}
            <Responsive phone>
              <div className={classNames(styles['phone-buttons'])} onClick={stopPropagation}>
                {actionButtonPhone}
              </div>
            </Responsive>
            <Responsive tablet>
              <div className={styles['controls']} onClick={stopPropagation}>
                {actionButtonDesktop}
              </div>
            </Responsive>
          </LinkArea>
        </div>
      </div>
    </CardContainer>
  );
});

export const Card = React.memo(CardComponent);
